/* unplugin-vue-components disabled */import { render } from "./MainNavbar.vue?vue&type=template&id=1aad5f1b&scoped=true"
import script from "./MainNavbar.vue?vue&type=script&lang=js"
export * from "./MainNavbar.vue?vue&type=script&lang=js"

import "./MainNavbar.vue?vue&type=style&index=0&id=1aad5f1b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aad5f1b"]])

export default __exports__